import { type Consumer, createConsumer } from '@rails/actioncable'

// Shared Action Cable consumer (one WebSocket per tab). All realtime hooks reuse
// this so we don't open a separate connection per subscription.
let consumer: Consumer | null = null

export function cable(): Consumer {
  if (!consumer) consumer = createConsumer()
  return consumer
}
